<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Outside Township Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <label>Name</label>
      <v-text-field v-model.trim="outside_township.name" type="text" outlined dense></v-text-field>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="outside_township.id" @click="emitOutsideTownshipData" class="form-btn">Update</v-btn>
      <v-btn v-else @click.prevent="emitOutsideTownshipData" class="form-btn">Submit</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    outside_township: {
      type: Object,
      default: () => {
        return {
          name: null
        };
      }
    }
  },
  data: () => ({}),

  computed: {
    ...mapState("Loading", ["loading"])
  },

  methods: {
    emitOutsideTownshipData() {
      if (this.outside_township.name) {
        let data = {
          name: this.outside_township.name,
          township_id:this.$route.params.township_id
        };

        this.outside_township.id ? (data.id = this.outside_township.id) : false;

        this.$emit("emitOutsideTownshipData", data);
      }
    }
  }
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
